// extracted by mini-css-extract-plugin
export default {"container":"ResetPassword_container__okJso"};